function fetchQuestionnaire(primaryUrl, fallbackUrl, payload, headers) {
  return fetch(primaryUrl, {
    method: 'POST',
    headers,
    body: JSON.stringify(payload)
  })
    .then(response => {
      if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
      return response.json();
    })
    .then(data => {

      if (Array.isArray(data) && data.length > 0) {
        return data;
      } else {
        console.warn('⚠️ Primary API returned empty, trying fallback...');
        return fetch(fallbackUrl, {
          method: 'POST',
          headers,
          body: JSON.stringify(payload)
        })
          .then(fallbackResponse => {
            if (!fallbackResponse.ok) throw new Error(`Fallback HTTP error! Status: ${fallbackResponse.status}`);
            
            return fallbackResponse.json();
          });
      }
    });
}

// Usage
const primaryUrl = 'https://app.alyvewellness.com/api/proxy_get_latest_questionnaire?isActive=true';
const fallbackUrl = 'https://app.alyvewellness.com/api/proxy_get_latest_questionnaire';

const payload = {
  tokenId: btoa(`gid://shopify/Customer/${window.customer_id}`),
  limit: 1
  // skip: 3,
  // _limit: 3
};


const headers = {
  'Content-Type': 'application/json',
  'x-customer-email': window.email,
  'x-customer-id':window.customer_id,
  'x-customer-signature': window.token_hmac,
  'x-shopify-shop-domain': 'alyve-store.myshopify.com'
};

  const texts = {
     diet: {
      title: 'Diet',
      texts: [
        { from: 0, to: 59, text: `It looks as though there is good room for improvement with your diet.` },
        { from: 60, to: 79, text: `You seem to have a good basic level for your diet.` },
        { from: 80, to: 89, text: `Your score indicates you already have a very healthy diet.` },
        { from: 90, to: 100, text: `Great work! You seem to be thoroughly looking after your diet.` }
      ],
    },
    overall: {
      title: 'Overall',
      texts: [
        { from: 0, to: 59, text: `It looks as though there is good room for improvement with your overall wellness.` },
        { from: 60, to: 79, text: `You seem to have a good basic level for your overall wellness.` },
        { from: 80, to: 89, text: `Your score indicates you already have a very healthy overall wellness.` },
        { from: 90, to: 100, text: `Great work! You seem to be thoroughly looking after your overall wellness.` }
      ],
    },   
    lifestyle: {
      title: 'Lifestyle',
      texts: [
        { from: 0, to: 59, text: `It looks as though there is good room for improvement with your lifestyle activities.` },
        { from: 60, to: 79, text: `You seem to have a good basic level for your lifestyle activities.` },
        { from: 80, to: 89, text: `Your score indicates you already have a very healthy lifestyle.` },
        { from: 90, to: 100, text: `Great work! You seem to be thoroughly looking after your lifestyle activities.` }
      ],
    }
  };

  function getTextsForStats(statKey, points) {
    const specificTexts = texts[statKey];
    const pointsMatchingText = specificTexts.texts.find(txtObj => points >= txtObj.from && points <= txtObj.to);
    return {
      title: specificTexts.title,
      text: pointsMatchingText?.text || ''
    };
  }

  function calcStats(questions) {
    let overall = 0;
    let lifestyle = 0;
    let diet = 0;

    console.log('📊 Questions:', questions);
    
    const addPointsFromAnswer = (answer) => {
      const { life_style_point, overall_point, diet_point } = answer;
      if (life_style_point) lifestyle += life_style_point ?? 0;
      if (overall_point) overall += overall_point ?? 0;
      if (diet_point) diet += diet_point ?? 0;
      console.log('🧩 Answer Object:', answer);
    };

    questions.forEach((question) => {
      const { answered_with } = question;
      if (Array.isArray(answered_with)) {
        answered_with.forEach(addPointsFromAnswer);
      } else if (answered_with && typeof answered_with === 'object') {
        addPointsFromAnswer(answered_with);
      }
    });

    return [
      { key: 'diet', ...getTextsForStats('diet', diet), points: diet },
      { key: 'overall', ...getTextsForStats('overall', overall), points: overall },
      { key: 'lifestyle', ...getTextsForStats('lifestyle', lifestyle), points: lifestyle }
    ];
  }
  console.log("fetchQuestionnaire",headers);
fetchQuestionnaire(primaryUrl, fallbackUrl, payload, headers)
  .then(data => {
    console.log('✅ API Response in scores:', data);

    // const latest = data?.reduce((a, b) => (a.id > b.id ? a : b));
    // const questions = latest?.results?.questions || [];

    let latest = null;
    let questions = [];
    
    if (Array.isArray(data) && data.length > 0) {
      latest = data.reduce((a, b) => (a.id > b.id ? a : b));
      questions = latest?.results?.questions || [];
    } else {
      console.warn('⚠️ No valid questionnaire data found.');
    }
        
    const stats = calcStats(questions);
    console.log("stats in scores: ", stats);

    const container = document.querySelector('.scoresContainer .swiper-wrapper');

    if (container) {
      // clear loader
      container.innerHTML = '';

      stats.forEach((stat, index) => {
        const chartId = `chart-${index}`;
        const box = document.createElement('div');
        box.className = 'swiper-slide'; // each slide
        box.innerHTML = `
          <div class="scoreBox" style="position: relative;">
            <div class="scorebox-inner">
              <div style="width: 150px; height: 150px; margin: auto; position: relative;">
                <canvas id="${chartId}" width="150" height="150"></canvas>
              </div>
              <h2>${stat.title}</h2>
              <p>${stat.text}</p>
            </div>
          </div>
        `;
        container.appendChild(box);

        // colors for each stat type
        // ✅ function to get color based on percentage
        function getColorByValue(value) {
          if (value <= 40) return '#FF8251';   // red
          if (value <= 69) return '#FFC800';   // orange
          return '#00BD03';                    // green
        }


        const ctx = document.getElementById(chartId).getContext('2d');
        new Chart(ctx, {
          type: 'doughnut',
          data: {
            datasets: [{
              data: [stat.points, 100 - stat.points],
              backgroundColor: [getColorByValue(stat.points), '#E5E5E5'],
              borderWidth: 0
            }]
          },
          options: {
            cutout: '95%',
            responsive: false,
            plugins: {
              legend: { display: false },
              tooltip: { enabled: false }
            }
          },
          plugins: [{
            id: 'centerText',
            beforeDraw: (chart) => {
              const { width, height, ctx } = chart;
              ctx.restore();

              const text = `${stat.points}`;
              const subText = '%';
              ctx.fillStyle = '#000';

              const fontSize = (height / 4).toFixed(2);
              ctx.font = `${fontSize}px sans-serif`;
              const textWidth = ctx.measureText(text).width;

              const subFontSize = (height / 12).toFixed(2);
              ctx.font = `${fontSize}px sans-serif`;
              const totalWidth = textWidth + ctx.measureText(subText).width * (subFontSize / fontSize);

              const textX = Math.round((width - totalWidth) / 2);
              const textY = height / 2;

              ctx.textBaseline = 'middle';
              ctx.font = `${fontSize}px sans-serif`;
              ctx.fillText(text, textX, textY);

              ctx.font = `${subFontSize}px sans-serif`;
              ctx.fillText(subText, textX + textWidth + 2, textY + 7);

              ctx.save();
            }
          }]
        });
      });

      // ✅ init Swiper AFTER slides are created
      let swiper;

      function initSwiper() {
        if (window.innerWidth < 768) {
          if (!swiper) { // only init if not already initialized
            swiper = new Swiper('.scoresContainer', {
              slidesPerView: 1,
              loop: false,
              pagination: {
                el: '.scores-pagination',
                clickable: true,
              },
            });
          }
        } else {
          if (swiper) { // destroy if window wider than 768
            swiper.destroy(true, true);
            swiper = undefined;
          }
        }
      }

      // run on load
      initSwiper();

      // run on resize
      window.addEventListener('resize', () => {
        initSwiper();
      });

    }

})
.catch(error => {
  console.error('❌ Failed to load questions:', error.message);
});
  